import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// Register Facebook SDK
import './assets/facebook-sdk.js'
// Register BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import smoothscroll from 'smoothscroll-polyfill'
import VueGtag from 'vue-gtag'
import VideoModal from '@/components/VideoModal.vue'
import * as Utils from './utils'
import { setCampaign } from '@/utils'
import { WebviewConfigState } from './store/webviewConfig'
import VueMeta from 'vue-meta'
const isDebugMode = process.env.NODE_ENV !== 'production'
const isStagingMode = process.env.VUE_APP_ENV === 'staging'

// Redirect to HTTPS
if (!isDebugMode) {
  if (location.protocol !== 'https:') {
    location.replace(`https:${location.href.substring(location.protocol.length)}`)
  }
}

// kick off the polyfill
smoothscroll.polyfill()

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// Vue Meta
Vue.use(VueMeta)
Vue.use(VueGtag, {
  config: { id: 'UA-34196650-21' },
  includes: [
    { id: 'AW-999021361', params: { allow_enhanced_conversions: true } }
  ]
}, router)

Vue.config.productionTip = isDebugMode || isStagingMode
Vue.config.devtools = isDebugMode || isStagingMode

Vue.directive('scroll', {
  inserted: (element, binding) => {
    const f = (event: Event) => {
      if (binding.value(event, element)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})
Vue.component('videoModal', VideoModal)

// Errors handling
window.onerror = function errorHandler (msg, url, line, column, error): void {
  store.commit('logger/PUSH_LOG', 'ERROR:')
  store.commit('logger/PUSH_LOG', { msg, url, line, column, error })
}
Vue.config.errorHandler = function (err, vm, info) {
  store.commit('logger/PUSH_LOG', 'ERROR in Vue:')
  store.commit('logger/PUSH_LOG', { err, info })
}

// Set function for webview invoke
window.setWebViewInfo = (payload : any) => {
  const info = JSON.parse(payload) as WebviewConfigState
  store.commit('webview/SET_WEBVIEW', info)
  store.commit('logger/SET_SERVER', info.upload_image_server)
  store.commit('logger/PUSH_LOG', payload)
}

window.navigateToCart = () => {
  if (router.currentRoute.name === 'Cart') {
    window.handleGetCartList()
  } else {
    router.push({ name: 'Cart', query: router.currentRoute.query })
  }
}

window.navigateToOrder = () => {
  if (router.currentRoute.name === 'Order') {
    window.handleGetOrderList()
  } else {
    router.push({ name: 'Order', query: router.currentRoute.query })
  }
}

// Environment
console.log(process.env.VUE_APP_VERSION)
console.log(process.env.VUE_APP_BASE_API)
const entryUrl = window.location.href
const hostId = Utils.getAndSetHostIdFromUrl(entryUrl) || Utils.getAndSetHostIdFromLocalStorage()
const campaign = Utils.getCampaignFromUrl(entryUrl)
const tokenInUrl = Utils.getTokenFromUrl(entryUrl)

store.commit('SET_WEBVIEW_MODE', /webview=1/.test(entryUrl))
if (campaign !== null) {
  setCampaign(campaign)
  const curUrl = new URL(location.href)
  curUrl.searchParams.delete('campaign')
  window.history.replaceState({}, '', curUrl.href)
  store.commit('webview/SET_WEBVIEW', { bank_name: campaign })
}
store.commit('SET_COUNTRY', localStorage.getItem('eco/country'))

// Initialize
store.dispatch('GET_WEBAPPCAPS')
if (!store.getters.isWebViewMode) {
  // Facebook.initializeApp()
  store.commit('INITIALIZE_TOKEN')
  store.commit('INITIALIZE_USER_INFO')
  store.dispatch('REFRESH_TOKEN')
} else {
  store.commit('SET_TOKEN_ONLY', tokenInUrl)
}

// Logs
store.commit('logger/INITIALIZE_LOG')
store.dispatch('logger/UPLOAD_LOG', { token: store.getters.isWebViewMode ? tokenInUrl : store.getters.token, isOrderUpload: false })

store.commit('logger/PUSH_LOG', `Web version: ${process.env.VUE_APP_VERSION}`)
store.commit('logger/PUSH_LOG', `Browser: ${Utils.getBrowser()}`)
store.commit('logger/PUSH_LOG', `Entry point: ${entryUrl}`)
store.commit('logger/PUSH_LOG', `isWebViewMode: ${/webview=1/.test(entryUrl)}`)
store.commit('logger/PUSH_LOG', `Host ID: ${hostId}`)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
